/* Dashboard-specific constants.
   No fixture/mock data lives here (ALL-4747 G6). Every tile on /home is
   either derived from a live API response or explicitly renders a
   "not available yet" state when no backend exists for it — see
   context/page_pipeline/pages/home.md G1 data inventory for the per-tile
   build/drop decision. */

export const DASHBOARD_RECENT_TRANSFER_LIMIT = 5;
export const DASHBOARD_APPROVAL_QUEUE_LIMIT = 5;
export const DASHBOARD_NOTIFICATION_LIMIT = 5;
export const DASHBOARD_TOP_WALLET_LIMIT = 3;
export const DASHBOARD_CHAIN_OTHERS_THRESHOLD = 0.05;
